import { PATH_WIDTH, X_STEP_UP, Y_SCALE_VALUE } from 'constants/map';
import { Path } from '../../Path';
import { Position, Station } from 'pages/Map/types';

type LabelPosition =
    | (Position & {
          type: 'vertical' | 'horizontal';
      })
    | null;
export const getLabelPosition = (path: Path, paths: Path[]): LabelPosition => {
    const haveMulitplePathsFromSource = paths.some(
        currentPath => path.source.id === currentPath.source.id && path.getId() !== currentPath.getId()
    );
    const points = path.getPoints();
    if (points.length === 0) return null;
    if (!haveMulitplePathsFromSource) {
        return {
            x: points[0].x - PATH_WIDTH,
            y: points[0].y + Y_SCALE_VALUE / 6,
            type: 'vertical'
        };
    }

    let position;
    points.some((labelPoint, index) => {
        const hasOveralappingPath = paths.some(
            currentPath =>
                path.getId() !== currentPath.getId() &&
                currentPath.getPoints().some(point => labelPoint.x === point.x && labelPoint.y === point.y)
        );
        const prevPoint = index - 1 >= 0 ? points[index - 1] : null;
        const nextPoint = index + 1 <= points.length - 1 ? points[index + 1] : null;
        const isHalfHorizontalPath = prevPoint
            ? Math.abs(labelPoint.x - prevPoint.x) === X_STEP_UP && nextPoint
                ? labelPoint.y !== nextPoint.y
                : false
            : false;

        if (!hasOveralappingPath && !isHalfHorizontalPath) {
            const isOnVerticalPath = prevPoint ? labelPoint.x === prevPoint.x : nextPoint ? labelPoint.x === nextPoint.x : false;
            position = {
                x: labelPoint.x - (isOnVerticalPath ? PATH_WIDTH : 0),
                y: labelPoint.y - PATH_WIDTH - (isOnVerticalPath ? Y_SCALE_VALUE / 6 : 15),
                type: isOnVerticalPath ? 'vertical' : 'horizontal'
            };
            return true;
        }
    });

    /* eslint-disable @typescript-eslint/no-unnecessary-condition */
    if (position) return position;

    const haveMulitplePathsToTarget = paths.some(
        currentPath => path.target.id === currentPath.target.id && path.getId() !== currentPath.getId()
    );
    if (haveMulitplePathsToTarget) {
        return null;
    }

    return {
        x: points[points.length - 1].x - PATH_WIDTH,
        y: points[points.length - 2].y + Y_SCALE_VALUE / 6,
        type: 'vertical'
    };
};

export const shouldIncreaseZIndexOfPathStation = (station: Station, paths: Path[], path?: Path) => {
    if (!path || !station.isSourceOrTargetForPath(path) || path.isLoopBackPath()) {
        return false;
    }

    const position = getLabelPosition(path, paths);
    return position?.type === 'vertical';
};
